<script>
export default {
    name: "AccountsMasterDataPortal",
}
</script>
<template>
  <tail-base-layout>
      <template v-slot:content>
        <div class="flex flex-wrap mt-4">
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.store-locations.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-green-600"><i class="fas fa-warehouse fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Store Locations</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-orange-100 border-b-4 border-orange-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.shelves.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-orange-600"><i class="fas fa-archive fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Shelves</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.packaging.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-yellow-600"><i class="fas fa-box-open fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Packaging</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.price-schemes.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-file-invoice-dollar fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Price Schemes</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.stock-adjustment-types.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-500"><i class="fas fa-search-dollar fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Stock Adjustment Types</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-red-100 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.item-categories.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-red-600"><i class="fas fa-boxes fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Item Categories</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.item-groups.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-people-carry fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Item Groups</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-purple-100 border-b-4 border-purple-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.item-types.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-purple-600"><i class="fas fa-layer-group fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Item Types</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-pink-100 border-b-4 border-pink-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.supplier-journal-categories.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-pink-600"><i class="fas fa-folder-open fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Supplier Journal Categories</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-pink-100 border-b-4 border-pink-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.coas.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-pink-600">
                                        <i class="fas fa-envelope fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Chart Of Accounts</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.financial-periods.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600">
                                        <i class="fas fa-clock fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Financial Periods</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3">
                    <div class="bg-purple-100 border-b-4 border-purple-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `master-data.accounts.expense-items.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-purple-600"><i class="fas fa-layer-group fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Expense Items</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
      </template>
</tail-base-layout>
</template>